const withNameSpace = (nameSpace, fieldName) => (nameSpace ? `${nameSpace}.${fieldName}` : fieldName);

export default withNameSpace;
